module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/passthrough.js
// module id = 802
// module chunks = 1